module.exports = __webpack_public_path__ + "b207e9a1408fa331744817e463fde19a.jpg";